import React, {useContext} from "react";
import {userInfoContext} from "../App";
import {useMsal} from "@azure/msal-react";

import LogoContainer from "./Serving/LogoContainer";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import "../style/topBar.css";
import {Link} from "react-router-dom";

export default function TopBar() {
    const [userInfo] = useContext(userInfoContext);
    const {instance} = useMsal();

    const handleLogout = () => {
        instance.logoutRedirect().catch((e) => {
            console.log("error", e);
        });
    };

    return (
        <div className="TopBar">
            <div className="leftAlignedItems">
                <LogoContainer/>
            </div>
            <div className="rightAlignedItems">
                <div className="menu-profile-card">
                    {userInfo.ImageUrl && userInfo.ImageUrl.trim() !== '' ? (
                        <img 
                            className="profile-image-menu" 
                            src={userInfo.ImageUrl} 
                            alt="Profile"
                            onError={(e) => {
                                e.currentTarget.src = `${process.env.PUBLIC_URL}/no-profile-image.png`;
                            }}
                        />
                    ) : (
                        <img 
                            className="profile-image-menu" 
                            src={`${process.env.PUBLIC_URL}/no-profile-image.png`}
                            alt="Profile"
                        />
                    )}

                    <div className="profile-info-container">
                        <div className="profile-name">{userInfo.Name}</div>
                        <div className="edit-profile-link-div">
                            <Link className="edit-profile-link" to="/profile">
                                <button className="edit-profile-button">Profil og royalty</button>
                            </Link>
                        </div>
                    </div>
                </div>
                <button className="logout-icon-button" onClick={handleLogout} title="Logg ut">
                    <LogoutOutlinedIcon />
                </button>
            </div>
        </div>
    );
}
